module.exports = __webpack_public_path__ + "static/img/switch_gary.72dd9b44.png";